<template>
	<div class="order-list-page">
		<el-tabs v-model="tabName">
			<el-tab-pane name="0">
				<span slot="label">
					可用券
				</span>
			</el-tab-pane>
			<el-tab-pane name="1">
				<span slot="label">
					历史记录
				</span>
			</el-tab-pane>
		</el-tabs>
		<coupon-page v-show="tabName == 0" useStatus="0"></coupon-page>
		<coupon-page v-show="tabName == 1" useStatus="1"></coupon-page>
	</div>
</template>

<script>
	import couponPage from './couponPage.vue'
	
	export default {
		name: 'my-coupon',
		components: {
			couponPage
		},
		data() {
			return {
				tabName: '0',
			};
		},
		methods: {
		}
	}
</script>

<style lang="scss" rel="stylesheet/scss">
	@import "@/assets/css/szui.scss";
	
	.order-list-page {
		min-height: 386px;
		
		.el-tabs  {
			.el-tabs__header {
				margin: 0 0 10px;
				padding-left: 20px;
				height: 60px;
				background: #FFFFFF;
				border-radius: 8px;
				
				.el-tabs__nav-wrap::after {
					content: none;
				}
				
				.el-tabs__item {
					position: relative;
					padding: 0 30px;
					height: 60px;
					line-height: 60px;
					color: $fontColor;
					
					.tag {
						position: absolute;
						top: 15px;
						left: 75px;
						padding: 0 6px;
						height: 16px;
						line-height: 16px;
						background: #F43232;
						border-radius: 8px;
						font-size: 13px;
						font-weight: 400;
						color: #FFFFFF;
					}
				}
				
				.is-top:nth-child(2) {
					padding-left: 0 !important;
				}
				
				.is-active {
					font-weight: bold;
				}
			}
		}
	}
</style>
